export enum UserClaims {
	all = '*',
	authorized = 'authorized',
	system = 'system',
	lsb = 'lsb',
	allAccess = '-1',
	globalAdmin = 'Global Admin',
}

export enum UserClaimTypes {
	SITE = 'Site',
	ACCOUNT = 'Account',
	allAccess = '-1',
}

export enum ClaimPermissions {
	ReadOnly = 'readOnly',
	ViewEdit = 'viewEdit',
}

export enum SiteClaimSection {
	system = 'system',
	lsb = 'lsb',
}

export enum RoleClaims {
	DenyAccrueInvoicesOnSNPOs = 'DenyAccrueInvoicesOnSNPOs',
	HideBankAccountNumber = 'HideBankAccountNumber',
	FundManagementAccountsPayableDocMgmtConfidential = 'FundManagementAccountsPayableDocMgmtConfidential',
	FundManagementAccountsPayableDocMgmtDelete = 'FundManagementAccountsPayableDocMgmtDelete',
	FundManagementManageRequisitionsDocMgmtConfidential = 'FundManagementManageRequisitionsDocMgmtConfidential',
	FundManagementManageRequisitionsDocMgmtDelete = 'FundManagementManageRequisitionsDocMgmtDelete',
	FundManagementPurchaseOrdersDocMgmtConfidential = 'FundManagementPurchaseOrdersDocMgmtConfidential',
	FundManagementPurchaseOrdersDocMgmtDelete = 'FundManagementPurchaseOrdersDocMgmtDelete',
	PayrollManageEmployeesDocMgmtConfidential = 'PayrollManageEmployeesDocMgmtConfidential',
	PayrollManageEmployeesDocMgmtDelete = 'PayrollManageEmployeesDocMgmtDelete',
	FundManagementAccountsReceivableDocMgmtConfidential = 'FundManagementAccountsReceivableDocMgmtConfidential',
	FundManagementAccountsReceivableDocMgmtDelete = 'FundManagementAccountsReceivableDocMgmtDelete',
	FundManagementJournalEntriesDocMgmtConfidential = 'FundManagementJournalEntriesDocMgmtConfidential',
	FundManagementJournalEntriesDocMgmtDelete = 'FundManagementJournalEntriesDocMgmtDelete',
	FundManagementVendorsDocMgmtConfidential = 'FundManagementVendorsDocMgmtConfidential',
	FundManagementVendorsDocMgmtDelete = 'FundManagementVendorsDocMgmtDelete',
	BudgetBuilderManageVersionsDocMgmtConfidential = 'BudgetBuilderManageVersionsDocMgmtConfidential',
	BudgetBuilderManageVersionsDocMgmtDelete = 'BudgetBuilderManageVersionsDocMgmtDelete',
	FundManagementBankEntriesDocMgmtConfidential = 'FundManagementBankEntriesDocMgmtConfidential',
	FundManagementBankEntriesDocMgmtDelete = 'FundManagementBankEntriesDocMgmtDelete',
	EmployeeStaffActionsCanSeeAll = 'EmployeeStaffActionsCanSeeAll',
	EmployeeStaffActionsDocMgmtConfidential = 'EmployeeStaffActionsDocMgmtConfidential',
	EmployeeStaffActionsDocMgmtDelete = 'EmployeeStaffActionsDocMgmtDelete',
	DisplayBenefitJobClassField = 'DisplayBenefitJobClassField',
	FixedAssetAssetDocMgmtConfidential = 'FixedAssetAssetDocMgmtConfidential',
	FixedAssetAssetDocMgmtDelete = 'FixedAssetAssetDocMgmtDelete',
	WorkshopManagementDocMgmtConfidential = 'WorkshopManagementDocMgmtConfidential',
	WorkshopManagementDocMgmtDelete = 'WorkshopManagementDocMgmtDelete',
	ReviewEmployeeLinqCeusDocMgmtConfidential = 'ReviewEmployeeLinqCeusDocMgmtConfidential',
	ReviewEmployeeLinqCeusDocMgmtDelete = 'ReviewEmployeeLinqCeusDocMgmtDelete',
	PayrollReclassifyChecksDocMgmtConfidential = 'PayrollReclassifyChecksDocMgmtConfidential',
	PayrollReclassifyChecksDocMgmtDelete = 'PayrollReclassifyChecksDocMgmtDelete',
	FundReclassifyChecksDocMgmtConfidential = 'FundReclassifyChecksDocMgmtConfidential',
	FundReclassifyChecksDocMgmtDelete = 'FundReclassifyChecksDocMgmtDelete',
	EmployeeCeuDocMgmtDelete = 'EmployeeCeuDocMgmtDelete',
	EmployeeCeuDocMgmtConfidential = 'EmployeeCeuDocMgmtConfidential',
	FundCashCustomerAccountsReceivableDocMgmtDelete = 'FundCashCustomerAccountsReceivableDocMgmtDelete',
	FundCashReceiptsDocMgmtConfidential = 'FundCashReceiptsDocMgmtConfidential',
	FundCashReceiptsDocMgmtDelete = 'FundCashReceiptsDocMgmtDelete',
	PrintChecksOverride = 'PrintChecksOverride',
}

export enum RoleClaimDescription {
	DocMgmtConfidentialAccess = 'Document Management - User has access to confidential documents',
	DocMgmtDeleteAccess = 'Document Management - User has the ability to delete documents',
}
